import React from "react";

import PrismicImgix from "@sendmagic/prismic-nextjs/src/components/Imgix";
import { PrismicLinkTag } from "@sendmagic/prismic-nextjs/src/components/LinkTag";

import { GetScreenType } from "@sendmagic/prismic-nextjs/src/helpers/device";
import { checkContentPresence } from "@sendmagic/prismic-nextjs/src/helpers/prismic";

import { textResolver } from "@sendmagic/prismic-nextjs/src/constants/text-resolver";
import { MOBILE_SCREEN_TYPE } from "@sendmagic/prismic-nextjs/src/constants/style";

const LargeImageHeader = ({ doc }) => {
  const {
    heading,
    subheading,
    image,
    internal_link_id,
    mobile_image,
    background_color,
    top_header_text,
  } = doc?.primary || {};

  const isMobileView = typeof window !== "undefined" && GetScreenType() === MOBILE_SCREEN_TYPE;

  const isLinkAvailable = doc?.items.some((item) => item.link?.url);

  const renderCta = () =>
    isLinkAvailable && (
      <div className="d-flex flex-wrap justify-content-center mt-4 start-an-order-home-btn position-relative text-only-banner-btns-row">
        {doc?.items?.map(({ link, text, button_design }, idx) => {
          const subLinkClassName =
            button_design === "transparent_background"
              ? "button-program-outline-green"
              : "button-program-green";
          const linkClassName = ["solid_background", "transparent_background"].includes(
            button_design,
          )
            ? `button ${subLinkClassName}
          btn d-inline-block font-weight-bold no-underline text-white text-uppercase text-break ls-1 button-marketing`
            : "sns-h4 program-link text-uppercase font-weight-bold ls-1";
          return (
            <div key={`program-index-${idx}`} className="mt-md-0 mx-2 mx-2xl-2 w-100">
              {link?.url && (
                <PrismicLinkTag
                  urlText={text}
                  url={link?.url}
                  target={link?.target}
                  className={linkClassName}
                />
              )}
            </div>
          );
        })}
      </div>
    );

  return (
    <div
      className="pt-md-5 pt-2xl-5 pt-5 pb-md-5 pb-5 large-image-section prismic-slice"
      style={{ background: background_color }}
    >
      {internal_link_id && (
        <span id={internal_link_id} className="scroll-point position-relative d-block" />
      )}
      <div className="container container-width container-2xl text-center large-image-section-container">
        <div className="mb-3 large-image-section-header-text">
          {checkContentPresence(top_header_text) && textResolver(top_header_text)}
        </div>
        <h2 className="sns-h2 font-weight-bold large-image-title same-size-title">
          {checkContentPresence(heading) && textResolver(heading, { convertToNormalText: true })}
        </h2>
        <div className="mt-2 sns-h5 large-image-message">
          {checkContentPresence(subheading) && textResolver(subheading)}
        </div>
        {!isMobileView && renderCta()}
        <div className="large-image-row">
          {image?.url && (
            <PrismicImgix
              className="img-responsive img-responsive-height d-none d-md-inline-block w-100"
              src={image?.url}
              alt={image?.alt}
              desktop="1200px"
              tablet="700px"
              largeDisplay="2000px"
            />
          )}
          {mobile_image?.url && (
            <PrismicImgix
              className="d-md-none img-responsive img-responsive-height"
              src={mobile_image?.url}
              alt={mobile_image?.alt}
            />
          )}
        </div>
        {isMobileView && renderCta()}
      </div>
    </div>
  );
};

export default LargeImageHeader;
